import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type State = {
  from: string | null
  params: any | null
}

const initialState: State = {
  from: null,
  params: null,
}

const { actions, reducer } = createSlice({
  name: 'backFlow',
  initialState,
  reducers: {
    setBackFlow: (state, action: PayloadAction<State>) => {
      state.from = action.payload.from
      state.params = action.payload.params
    },
    clearBackFlow: (state) => {
      state.from = null
      state.params = null
    },
  },
})

export { reducer }
export default actions
